import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getDeviceFingerprint } from '@admin-panel/utils';
import { buildHeaders, getPortalHeadersByName } from '@admin-panel/providers';
import { GATEWAY_API_URL, PORTAL_NAME } from '@admin-panel/config/env';

type OverrideFetchBaseQueryOptions = {
  baseUrl?: string;
  urlSuffix?: string;
  includePlatform?: boolean;
};

const buildBaseUrl = ({
  baseUrl = GATEWAY_API_URL,
  urlSuffix = '',
  includePlatform = true,
}: OverrideFetchBaseQueryOptions) => {
  const normalizedBaseUrl = (baseUrl ?? '').replace(/\/+$/, '');
  const resolvedBaseUrl = includePlatform
    ? normalizedBaseUrl
    : normalizedBaseUrl.replace(/\/[^/]+$/, '');

  return urlSuffix ? `${resolvedBaseUrl}/${urlSuffix}` : resolvedBaseUrl;
};

export function overrideFetchBaseQuery(options: OverrideFetchBaseQueryOptions = {}) {
  return fetchBaseQuery({
    baseUrl: buildBaseUrl(options),
    prepareHeaders: headers => {
      const at = localStorage.getItem('at');
      const rt = localStorage.getItem('rt');
      const { portalCode, app } = getPortalHeadersByName(PORTAL_NAME);

      return buildHeaders({
        headers,
        accessToken: at,
        refreshToken: rt,
        deviceId: getDeviceFingerprint(),
        portalCode,
        app,
      });
    },
    credentials: 'same-origin',
    mode: 'cors',
  });
}
